import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../shared/modal/modal";
import styles from "./modal-close-master-plan.module.scss";
import Button from "../../../../ui-kit/button/button";
import {
  clearAllSelected,
  setResetKrookieData,
} from "../../../../../services/reducers/master-plan-modification";
import { useAppDispatch } from "../../../../../hooks/useAppDispatch";
import { useNavigate } from "react-router-dom";
import { setEditingBorders } from "../../../../../services/actions/master-plan-modification";
import { stopDrawingTools } from "../../../../../services/reducers/map";
import { useAppSelector } from "../../../../../hooks/useAppSelector";

interface ModalCloseMasterPlan {
  onClose: () => void;
  targetRoute?: string;
}

const ModalCloseMasterPlan: FC<ModalCloseMasterPlan> = ({
  onClose,
  targetRoute,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { krookiePlots } = useAppSelector(
    (state) => state.masterPlanModification,
  );

  const clearAll = () => {
    dispatch(stopDrawingTools());
    if (krookiePlots.length) {
      dispatch(setEditingBorders("reset"));
    }
    dispatch(setResetKrookieData());
    navigate(targetRoute || "/search");
    dispatch(clearAllSelected());
    onClose();
  };

  return (
    <Modal onClose={onClose} showCloseBtn={false}>
      <div className={styles.modalCloseMasterPlan}>
        <div className={styles.body}>
          <span className={styles.title}>
            {t("modalCloseMasterPlan.title")}
          </span>
          <p className={styles.description}>
            {t("modalCloseMasterPlan.description")}
          </p>
        </div>
        <div className={styles.buttonSection}>
          <Button onClick={onClose} className={styles.returnBtn} type="primary">
            {t("modalCloseMasterPlan.returnBtn")}
          </Button>
          <Button onClick={clearAll} className={styles.closeBtn} type="outline">
            {t("modalCloseMasterPlan.closeBtn")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalCloseMasterPlan;
